module.exports = __webpack_public_path__ + "img/kartel-border.8375e85e.svg";